import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type ListProps = {
  $embedded: boolean;
};

export const List = styled.ul<ListProps>`
  border-radius: ${({ $embedded, theme }) => ($embedded ? 'none' : theme.menuList.borderRadius)};
  background-color: ${({ $embedded, theme }) =>
    $embedded ? ColorPalette.Transparent : theme.menuList.backgroundColor};
  box-shadow: ${({ $embedded, theme }) => ($embedded ? 'none' : theme.menuList.boxShadow)};
`;
